import { AutogenLayoutBreakthroughFuelHold } from "./autogen/AutogenLayoutBreakthroughFuelHold";
import {  DataSourceExecutionEvent } from "@mcleod/components";
import { BreakthroughFuelUtility } from "./BreakthroughFuelUtility";

export class BreakthroughFuelHold extends AutogenLayoutBreakthroughFuelHold {
    private _refreshTabsCallback?: () => void;

    set refreshTabsCallback(cb: () => void) {
        this._refreshTabsCallback = cb;
    }

    get refreshTabsCallback(): (() => void) | undefined {
        return this._refreshTabsCallback;
    }

    /** This is an event handler for the beforeExecution event of sourceBreakthroughTransaction. */
    sourceBreakthroughTransactionBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.on_hold = "Y";
    }

    /** This is an event handler for the onClick event of buttonDownload. */
    async buttonDownloadOnClick() {
        await BreakthroughFuelUtility.downloadBreakthroughFuelTransactions(this.buttonDownload, this.refreshTabsCallback);
    }
}
